<template>
  <div class="not-found">
    <h1>404</h1>
    <h2>Página No Encontrada</h2>
    <p>Lo sentimos, la página que estás buscando no existe.</p>
    <router-link to="/" class="btn-home">Volver al Inicio</router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="scss" scoped>
.not-found {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
  text-align: center;
  padding: 1rem;
  
  h1 {
    font-size: 6rem;
    font-weight: 700;
    color: #4299e1;
    margin: 0;
  }
  
  h2 {
    font-size: 2rem;
    color: #2d3748;
    margin: 0.5rem 0 1rem;
  }
  
  p {
    font-size: 1.1rem;
    color: #4a5568;
    margin-bottom: 2rem;
  }
  
  .btn-home {
    display: inline-block;
    padding: 0.75rem 1.5rem;
    background-color: #4299e1;
    color: white;
    text-decoration: none;
    border-radius: 4px;
    font-weight: 500;
    transition: background-color 0.2s;
    
    &:hover {
      background-color: #3182ce;
    }
  }
}
</style>